import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';
import { fetch_user_rights, update_user_rights_api } from '../api/api';
import { Link, redirect, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

function Permissions() {
    const location = useLocation();
    const userId = location.state?.userId;
    const [userRights, setUserRights] = useState([]);
    const redirect = useNavigate();

    useEffect(() => {
        fetch_user_rights_api_call();
    }, []);


    console.log(userRights)

    // Fetch user rights
    const fetch_user_rights_api_call = async () => {
        try {
            const res = await fetch_user_rights(userId);
            if (res.status === 200) {
                setUserRights(res.data.data);
            }
        } catch (error) {
            console.error("Error fetching user rights data", error);
        }
    };


    // Toggle permission
    const togglePermission = (moduleId, permissionType) => {
        setUserRights(prevRights =>
            prevRights.map(right =>
                right.id === moduleId
                    ? {
                        ...right,
                        [permissionType]: right[permissionType] === "1" ? "0" : "1",
                    }
                    : right
            )
        );
    };


    // Update user rights
    const update_user_rights_api_call = async () => {
        if (userRights.length === 0) return;

        const user_id = userRights[0].user_id;

        const formattedData = {
            user_id,
            module_id: userRights.map(right => right.module_id).join(','),
            create: userRights.map(right => right.create).join(','),
            read: userRights.map(right => right.read).join(','),
            update: userRights.map(right => right.update).join(','),
            delete: userRights.map(right => right.delete).join(','),
        };

        try {
            const res = await update_user_rights_api(formattedData);
            if (res.status === 200) {
                toast.success("Delivery boy rights updated successfully");
                redirect("/delivery-boy")
            } else {
                console.warn("Unexpected response status:", res.status);
                toast.error("Delivery boy rights update Error");
            }
        } catch (error) {
            console.error("Error updating rights:", error);
        }
    };


    return (
        <div className="wrapper">
            <Navbar />
            <Sidebar />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12 d-flex flex-column flex-sm-row justify-content-between">
                                <h1 className="m-0">Permissions</h1>
                                <span className='text-sm d-flex justify-content-end mt-4 mb-4 mt-sm-0 mb-sm-0'>
                                    <Link to="/dashboard">Dashboard</Link>
                                    <span className='ml-1 mr-1'>/</span>
                                    <Link to="/delivery-boy">Delivery Boy</Link>
                                    <span className='ml-1 mr-1'>/</span>
                                    <span>Permissions</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card delevery-boy-rights pt-4 pb-4">
                                    <div className="card-body table-responsive">
                                        <table>
                                            <tbody>
                                                {
                                                    userRights.map((module) => (
                                                        <React.Fragment key={module.id}>
                                                            <tr>
                                                                <td>
                                                                    <h5 className='pr-5 m-0'>{module.name}:</h5>
                                                                </td>
                                                                {
                                                                    ['create', 'read', 'update', 'delete'].map((permission) => (
                                                                        <React.Fragment key={permission}>
                                                                            <td>
                                                                                <label htmlFor={`${module.name}-${permission}`} className='pr-2'>
                                                                                    {permission.charAt(0).toUpperCase() + permission.slice(1)}
                                                                                </label>
                                                                            </td>
                                                                            <td>
                                                                                <input
                                                                                    type="checkbox"
                                                                                    id={`${module.name}-${permission}`}
                                                                                    className='check-box-form mr-5'
                                                                                    checked={module[permission] === "1"}
                                                                                    onChange={() => togglePermission(module.id, permission)}
                                                                                />
                                                                            </td>
                                                                        </React.Fragment>
                                                                    ))
                                                                }
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={9}><div className='pt-3 pb-3'></div></td>
                                                            </tr>
                                                        </React.Fragment>
                                                    ))
                                                }
                                                <tr>
                                                    <td colSpan={9}>
                                                        <div className='pt-5 d-flex justify-content-center'>
                                                            <button
                                                                className="btn btn-naariyal-green w-25 mt-3"
                                                                onClick={update_user_rights_api_call}
                                                            >
                                                                Save
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <Footer />
            <aside className="control-sidebar control-sidebar-dark"></aside>
        </div>
    );
}

export default Permissions;
